import { useParams } from "react-router-dom";
import MapCanvas from "./MapCanvas";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { Button, ListGroup, Offcanvas, OverlayTrigger, Popover } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import HelperService from "../../utility/HelperService";
import { Trash } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { TbBrandBooking } from "react-icons/tb";
import PageTitle from "../../components/PageTitle/PageTitle";
import routePaths from "../../Navigation/routePaths";
import TagInput from "../../components/TagInput/TagInput";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

interface IPlotData {
    id: number;
    coordinates: number[][];
    color: string;
    title: string;
    facing_direction?: string;
    area?: string;
    status?: string;
};

const MarkUnit = () => {
    const dispath = useDispatch();
    const { id } = useParams();
    const [tool, setTool] = useState("Polygon");
    const [selectedUnit, setSelectedUnit] = useState<any>();
    const [isManage, setIsManage] = useState(false);
    const [plotData, setPlotData] = useState<IPlotData[]>([]);
    const [fullPageLoder, setFullPageLoder] = useState(false);
    const [unitData, setUnitData] = useState<any>({ "Line": [] });
    const [unitList, setUnitList] = useState<any>([]);
    const [imageID, setImageID] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [projectImage, setProjectImage] = useState<string>("");
    const [openTagBlade, setOpenTagBlade] = useState<boolean>(false);
    const [markData, setMarkData] = useState<any>({});
    const [tags, setTags] = useState<string[]>([]);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [bookingPermissions, setBookingPermissions] = useState<permissionsInterface | null>(null);
    const [length, setLength] = useState<number>(0);
    const [width, setWidth] = useState<number>(0);


    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
            setBookingPermissions(token.permissions.find((item: any) => item.name === "BOOKINGS"));
        }
    }, [token]);

    useEffect(() => {
        if (permissions && permissions.can_read) {
            getProjectDetail();
            getMarkingData();
        }
    }, [permissions]);

    const getMarkingData = () => {
        WebService.getAPI({ action: `get/coordinates?project_uuid=${id}` })
            .then((res: any) => {
                const data: any = [];
                res.result && res.result.map((item: any) => {
                    data.push({ id: item.id, uuid: item.uuid, coordinates: JSON.parse(item.coordinates || '[]'), color: item.project_units?.status == "SOLD" ? "rgba(255, 0, 0, 0.6)" : "rgba(50, 205, 50, 0.2)", title: item.project_units?.unit_name, facing_direction: item.project_units?.facing_direction, area: item.project_units?.area, status: item.project_units?.status, project_units: item.project_units, tags: JSON.parse(item.tags || '[]') });
                });
                setPlotData(data);
                res.project_info && setProjectImage(res.project_info.project_image);
                console.log("res.project_info.length", res.project_info.length);


                setLength(res.project_info.length);
                setWidth(res.project_info.width);
                getUnitList(res.result);
            })
            .catch((e: any) => { });
    };

    const getProjectDetail = () => {
        WebService.getAPI({ action: `project/detail/${id}` })
            .then((res: any) => {
                if (res.result && res.result?.project_images && res.result?.project_images.length) {
                    // setProjectImage(res.result?.project_images[0]?.photo ? `${res?.base_url}${res.result?.project_images[0]?.photo}` : "");
                    if (res.result?.project_images && res.result?.project_images.length) {
                        setImageID(res.result?.project_images[0].id);
                    };
                }
            })
            .catch((e: any) => { });
    };

    const getUnitList = (coordiantes: any) => {
        setLoading(true);
        WebService.getAPI({ action: `get/project/unit/list?uuid=${id}` })
            .then((res: any) => {
                const list = res.list.map((item: any) => {
                    if (coordiantes && coordiantes.length > 0) {
                        const isExist = coordiantes.find((plot: any) => plot.unit_id == item.id);
                        return { ...item, value: item.uuid, label: isExist ? `${item.unit_name} (Marked)` : item.unit_name };
                    } else {
                        return { ...item, value: item.uuid, label: item.unit_name };
                    }
                });
                setUnitList(list);
                setLoading(false);
            })
            .catch((e: any) => { setLoading(false); });
    };

    const onStartMark = () => {
        if (selectedUnit) {
            setTool("Line")
            // WebService.postAPI({ action: `project/unit/mark`, body: { project_uuid: id, unit_uuid: selectedUnit.value, data: unitData } })
            //     .then((res: any) => {
            //         if (res.result) {
            //             setUnitData(unitInitialData);
            //             setResetCanvas(new Date().getTime());
            //         }
            //     })
            //     .catch((e: any) => { });
        } else {
            toast.error("Please select unit");
        }
    };

    const popoverHoverFocus = (plot: any) => {
        return (
            <Popover id="popover-basic" className="p-0">
                <ListGroup as="ul" className="border-0">
                    <ListGroup.Item as="li" className="border-0">Plot Name: {plot.title}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Facing: {plot.facing_direction}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Area: {plot.area}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Status: {plot.status}</ListGroup.Item>
                    {
                        plot.status == "SOLD" &&
                        <>
                            <ListGroup.Item as="li" className="border-0">Customer: {plot?.project_units?.customer_name} ({plot?.project_units?.customer_phone})</ListGroup.Item>
                            <ListGroup.Item as="li" className="border-0">Agent: {plot?.project_units?.agent_name} ({plot?.project_units?.agent_phone})</ListGroup.Item>
                        </>
                    }
                    {
                        plot?.tags && !!plot?.tags.length && <ListGroup.Item as="li" className="border-0">Tags: {plot?.tags.join(", ")}</ListGroup.Item>
                    }
                    {plot.status == "AVAILABLE" && bookingPermissions && bookingPermissions.can_write &&
                        <ListGroup.Item as="li" className="border-0 text-center cursor-pointer" style={{ backgroundColor: "#ffea9e", color: "rgb(255, 193, 7)" }} onClick={() => {
                            dispath({ type: "BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST", payload: { data: { ...plot.project_units, ...{ project_unit_id: plot?.project_units?.id } }, isEdit: false } });
                            dispath({ type: "NAVIGATION_REQUEST", payload: routePaths.BOOKING_CREATE.path });
                        }}>
                            <span className="badge text-warning p-0"><TbBrandBooking size={18} /> Book Now</span>{" "}
                        </ListGroup.Item>}
                    {permissions && permissions.can_update && <ListGroup.Item as="li" className="border-0 text-center cursor-pointer" style={{ backgroundColor: "#FDECEC", color: "#D53727" }} onClick={() => { onDeleteMark(plot) }}>
                        <span className="badge p-0" style={{ color: "#D53727" }}><Trash size={15} /> Remove</span>{" "}
                    </ListGroup.Item>}
                </ListGroup>
            </Popover>
        );
    };

    const onCompleteMark = (data: any) => {
        if (Object.keys(data || {}).length > 1) {
            setOpenTagBlade(true);
            setMarkData(data);
        }
    };

    const onDeleteMark = (plot: any) => {
        setFullPageLoder(true);
        WebService.deleteAPI({ action: `delete/coordinate/${plot.uuid}` })
            .then((res: any) => {
                setPlotData(plotData.filter((item: any) => item.id != plot.id));
                setFullPageLoder(false);
            })
            .catch((e: any) => { });
    };

    const closeModal = (e?: boolean) => {
        setOpenTagBlade(false);
        setMarkData(null);
        setTags([]);
    };

    const saveCoordinates = () => {
        if (Object.keys(markData || {}).length > 1) {
            const coordiante: any[] = Object.values(markData).filter((item: any) => item.length > 0);
            setFullPageLoder(true);
            WebService.postAPI({ action: `coordinate/create`, body: { project_uuid: id, unit_id: selectedUnit.id, project_image_id: imageID, coordinates: JSON.stringify(coordiante[0]), tags: JSON.stringify(tags) }, id: "add-cordinate-btn" })
                .then((res: any) => {
                    closeModal();
                    setTool("Polygon");
                    // plotData.push({ id: selectedUnit.uuid, coordinates: coordiante[0], color: selectedUnit.status == "SOLD" ? "red" : "green", title: selectedUnit.unit_name, facing_direction: selectedUnit.facing_direction, area: selectedUnit.area, status: selectedUnit.status });
                    setSelectedUnit(null);
                    setUnitData({ "Line": [] });
                    setIsManage(!isManage);
                    setFullPageLoder(false);
                    getMarkingData();
                    toast.success("Marking saved successfully");
                })
                .catch((e: any) => { });
        } else {
            closeModal();
        }
    };


    return (
        <>
            {permissions && permissions.can_read && <div style={{ height: `${length}px`, width: `${width}px`, overflow: "hidden" }} className="app-page">
                <div className="d-flex justify-content-between align-items-center ">
                    <PageTitle title="Mark Units" backArrow={true} />
                </div>
                <div className="d-flex gap-2 mb-3">
                    <div className="w-50">
                        <Select className="basic-single w-100" classNamePrefix="select" isLoading={loading}
                            isSearchable={true} options={unitList} onChange={(e: any) => { setSelectedUnit(e) }}
                            value={selectedUnit} placeholder="Select Unit" />
                    </div>
                    {!isManage && <Button variant="primary" className="btn-brand-solid me-3" type="button" onClick={() => { onStartMark(); setIsManage(!isManage) }} disabled={selectedUnit && !HelperService.isEmptyObject(selectedUnit) ? false : true}>
                        Start Marking
                    </Button>}
                </div>

                {
                    !isManage ?
                        <TransformWrapper>
                            <TransformComponent>
                                <svg style={{ height: `${length}px`, width: `${width}px`, backgroundImage: `url(${projectImage})`, backgroundSize: "cover", padding: "0px", overflow: "hidden" }}>
                                    {plotData && !!plotData.length && plotData.map((plot: any) => {
                                        const points = plot.coordinates.map(([x, y]: any) => `${x},${y}`).join(" ");
                                        return (
                                            <OverlayTrigger trigger={['click', 'focus']} placement="right" overlay={popoverHoverFocus(plot)} key={plot.id}>
                                                <g style={{ cursor: "pointer" }}>
                                                    <polygon points={points}
                                                        fill={plot.color}
                                                        // fill={'rgba(117, 190, 218, 0.2)'}
                                                        stroke={''} strokeWidth="2" />
                                                    {/* Calculate text width and polygon bounding box */}
                                                    {(() => {
                                                        // Calculate polygon centroid for better center placement
                                                        const getPolygonCentroid = (coords: [number, number][]) => {
                                                            let x = 0, y = 0, area = 0;
                                                            const n = coords.length;
                                                            for (let i = 0; i < n; i++) {
                                                                const [x0, y0] = coords[i];
                                                                const [x1, y1] = coords[(i + 1) % n];
                                                                const a = x0 * y1 - x1 * y0;
                                                                area += a;
                                                                x += (x0 + x1) * a;
                                                                y += (y0 + y1) * a;
                                                            }
                                                            area *= 0.5;
                                                            if (area === 0) return [coords[0][0], coords[0][1]];
                                                            x /= (6 * area);
                                                            y /= (6 * area);
                                                            return [x, y];
                                                        };
                                                        const [centroidX, centroidY] = getPolygonCentroid(plot.coordinates);

                                                        // Estimate text width (simple approximation: 8px per character)
                                                        const textWidth = plot.title ? plot.title.length * 8 : 40;
                                                        // Find bounding box of polygon
                                                        const xs = plot.coordinates.map(([x]: any) => x);
                                                        const ys = plot.coordinates.map(([, y]: any) => y);
                                                        const minX = Math.min(...xs);
                                                        const maxX = Math.max(...xs);
                                                        const minY = Math.min(...ys);
                                                        const maxY = Math.max(...ys);
                                                        const boxWidth = maxX - minX;
                                                        const boxHeight = maxY - minY;
                                                        // Set background width: min(boxWidth, textWidth + padding)
                                                        const bgWidth = Math.min(boxWidth, textWidth + 16);
                                                        const bgHeight = Math.min(boxHeight, 28);

                                                        return (
                                                            <>
                                                                <rect x={centroidX - bgWidth / 2} y={centroidY - bgHeight / 2} width={bgWidth} height={bgHeight} fill="rgba(117, 190, 218, 0.4)" rx={6} />
                                                                <text x={centroidX} y={centroidY} fill="#fff" fontSize="14" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                                                                    {plot.title}
                                                                </text>
                                                            </>
                                                        );
                                                    })()}
                                                </g>
                                            </OverlayTrigger>
                                        );
                                    })}
                                </svg>
                            </TransformComponent>
                        </TransformWrapper>
                        :
                        <div className="map-canvas">
                            {/* {projectDetail && projectDetail?.photo_url && */}
                            <MapCanvas data={unitData} onComplete={(e: any) => { onCompleteMark(e); }} url={projectImage} tool={tool} resetCanvas={""} height={length} width={width} />
                            {/* } */}
                        </div>
                }
            </div>}

            <Offcanvas show={openTagBlade} onHide={closeModal} placement="end">
                <Offcanvas.Header closeButton><Offcanvas.Title> Unit-{selectedUnit && selectedUnit.unit_name}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <TagInput
                        isAllowDuplicate={true}
                        onChange={(value: string[]) => { setTags(value && value.length > 0 ? value : []) }}
                        selected={tags || []}
                        title="Add Tags"
                        showStar={false}
                    />

                    <div className="text-center">
                        <Button
                            variant="dark"
                            className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                            type="button"
                            id="add-cordinate-btn"
                            onClick={() => {
                                saveCoordinates();
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            variant="light"
                            className="btn-brand-1 px-5 mt-3 mb-3"
                            type="button"
                            onClick={() => closeModal(false)}
                        >
                            Cancel
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default MarkUnit;